'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoHourglass = function GoHourglass(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.3 20c4.6-3.3 7.7-9.4 7.7-15 0-2.8-6.7-5-15-5s-15 2.2-15 5c0 5.6 3.1 11.7 7.7 15-4.6 3.3-7.7 9.4-7.7 15 0 2.8 6.7 5 15 5s15-2.2 15-5c0-5.6-3.1-11.7-7.7-15z m-7.3-17.5c5.5 0 10 1.1 10 2.5s-4.5 2.5-10 2.5-10-1.1-10-2.5 4.5-2.5 10-2.5z m-2.5 27.6c-6 0.3-9.3 1.5-9.9 3.2 0.6-4.5 2.9-7.4 5.5-9.8 2.9-2.7 4.4-2.4 4.4-4v10.6z m-4.1-13.8c-2.7-2.1-4.8-5-5.6-8.4 2.8 1.3 7.2 2.1 12.2 2.1s9.4-0.8 12.1-2.1c-0.7 3.4-2.8 6.3-5.5 8.4-0.9-0.6-2.7-1.3-6.6-1.3s-5.7 0.7-6.6 1.3z m9.1 13.8v-10.7c0 1.7 1.5 1.4 4.4 4 2.6 2.5 4.9 5.4 5.5 9.8-0.6-1.6-3.9-2.9-9.9-3.2z' })
        )
    );
};

exports.default = GoHourglass;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/hourglass.js
// module id = 1914
// module chunks = 0